import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Header from "../../components/Header";
import { getComplaints } from "../../redux/Complaints/complaintsAction";
import PendingAgentsTable from "../../tables/Agents/PendingAgentsTable";

const PendingAgents = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getComplaints({ page: 1, value: null }));
  }, [dispatch]);

  return (
    <div>
      <Header text="Pending Agents Approval"></Header>

      {/* TABLE SECTION */}
      <section className="mt-8">
        <PendingAgentsTable />
      </section>
    </div>
  );
};

export default PendingAgents;
